<template>
  <div id="questionOne"></div>
</template>

<script>
export default {
  name: "QuestionOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        question:
          "What's the biggest challenge you face when creating content?",
        context: "Drop your answer in the comments 👇",
        chip: "Let's Discuss",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const el = document.getElementById("questionOne");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const questionSize = exporting ? 64 : 64 * this.scale;
      const contextSize = exporting ? 32 : 32 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const chipSize = exporting ? 24 : 24 * this.scale;
      const iconSize = exporting ? 80 : 80 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#000000";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <div style="padding: 0 10%;">
            <div style="
              font-size: ${iconSize}px;
              margin-bottom: 24px;
            ">🤔</div>
            <div style="border-left: 6px solid ${primaryColor}; padding-left: 25px;">
              <div style="
                font-size: ${questionSize}px;
                font-weight: 600;
                color: #272727;
                line-height: 1.2;
                margin-bottom: 24px;
              ">${this.data.question}</div>
              ${
                this.data.context
                  ? `
              <div style="
                font-size: ${contextSize}px;
                font-weight: 400;
                color: #737373;
                line-height: 1.4;
              ">${this.data.context}</div>
              `
                  : ""
              }
            </div>
          </div>

          <div style="padding: 10%">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: ${primaryColor};
                  color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 7px 22px;
                  letter-spacing: 0.03em;
                  font-family: 'Inter', Arial, sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
